<template>
  <ion-footer>
    <ion-toolbar>
      <ion-buttons>
        <ion-button @click="navigateTo('ImpressumPage')">Impressum</ion-button>
        <ion-button @click="navigateTo('DatenschutzPage')">Datenschutz</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</template>

<script>
import {IonFooter, IonToolbar, IonButtons, IonButton} from '@ionic/vue';


export default {
  name: 'AppFooter',
  components: {
    IonFooter,
    IonToolbar,
    IonButtons,
    IonButton,
  },
  methods: {
    navigateTo(page) {
      this.$router.push({name: page});
    },
  },
};
</script>

<style scoped>
/* Add any custom styles for the footer here */
</style>